module.exports = __webpack_public_path__ + "img/loading-spinner.9e339a38.gif";